import React from "react";
import "./NotFound.css";
import { useNavigate } from "react-router-dom";
export const NotFound = () => {
  const navigate = useNavigate();
  return /* @__PURE__ */ React.createElement("div", { className: "NotFound" }, /* @__PURE__ */ React.createElement("h1", { className: "headline" }, "Not found"), /* @__PURE__ */ React.createElement("p", { className: "subhead" }, "Sorry, but the page you were looking for could not be found."), /* @__PURE__ */ React.createElement("p", { className: "helpful-links" }, /* @__PURE__ */ React.createElement("span", { className: "go-back-link", onClick: () => navigate(-1) }, "Go back")));
};
